import {
  ExamCardContext as ExamCardPreviewContext,
  type ExamCardProviderProps,
  type ExamCard,
} from '../exam-card';

const MOCK_EXAM_CARD_DATA = {
  id: '6d699db6-ce2c-42e4-89f3-87fbbfe29bdd',
  userId: '2eaceb4b-32bb-4f49-a115-fd979f61ea6a',
  examEventId: 'cf57383e-3883-4983-9d3d-5eeecc7af851',
  availableDate: new Date('2025-09-15T08:00:00.000Z'),
  expiryDate: new Date('2030-12-15T13:00:00.000Z'),
  metadata: {},
  seatNumber: null,
};

function ExamCardPreviewProvider({ children }: Readonly<ExamCardProviderProps>) {
  const contextValue = {
    examCard: MOCK_EXAM_CARD_DATA as ExamCard,
    loading: false,
    error: undefined,
  };

  return (
    <ExamCardPreviewContext.Provider value={contextValue}>
      {children}
    </ExamCardPreviewContext.Provider>
  );
}

export { ExamCardPreviewProvider };
